import { cn } from '@growtherapy/sprout-ui';

import { useTheme } from '../hooks/useTheme';
import { Theme } from '../state/theme';

export function PageContainer({ children, className }: { children: React.ReactNode; className?: string }) {
  const { theme } = useTheme();
  return (
    <div
      className={cn(
        {
          'bg-neutral-300 rebrand:bg-surface-default': theme === Theme.LIGHT,
          'bg-neutral-800 rebrand:bg-surface-inverse': theme === Theme.DARK,
        },
        'h-full flex flex-col page-background',
        className,
      )}
      data-testid='page-container'
    >
      {children}
    </div>
  );
}
